// @flow
// Externals
import React from "react";
import Lottie from "react-lottie-player";

// Styles
// $FlowFixMe
import "./index.scss";

// Animation Data
import animationData from "../../static/lottie/Q15.json";

// Question Animation
/*::
type Props = {
}
*/
const Animation = (props /*: Props */) /*: any */ => (
	<div className="animation animation-q17">
		<Lottie
			className="lottie-container basic"
			animationData={animationData}
			play={true}
			loop={true}
		/>
	</div>
);

// Exports
export default Animation;
